import { render, staticRenderFns } from "./course-video.vue?vue&type=template&id=2d622258&scoped=true&"
import script from "./course-video.vue?vue&type=script&lang=js&"
export * from "./course-video.vue?vue&type=script&lang=js&"
import style0 from "./course-video.vue?vue&type=style&index=0&id=2d622258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d622258",
  null
  
)

export default component.exports